import { AbstractControl, AsyncValidatorFn, ValidationErrors } from '@angular/forms';
import { Folder } from '@ca/core/models';
import { FileService } from '@ca/core/services';
import { Observable, of, timer } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

export class CheckFolderExistenceValidator {
    static createValidator(fileService: FileService, currentFolderId: string | undefined): AsyncValidatorFn {
        return (control: AbstractControl): Observable<ValidationErrors | null> => {
            if (control.dirty) {
                return timer(200).pipe(
                    switchMap(() => fileService.checkFolderExistence$([control.value.trim() as string], currentFolderId)),
                    map((folder: Folder) => (folder ? { errorFolderAlreadyExists: true } : null)),
                    catchError(() => {
                        return of({ errorFolderCheckExistence: true });
                    }),
                );
            }

            return of(null);
        };
    }
}
